import React from "react";
import { FaCheck } from "react-icons/fa";

const rules = [
  { label: "8 à 32 caractères", test: (p) => p.length >= 8 && p.length <= 32 },
  { label: "Une minuscule", test: (p) => /[a-z]/.test(p) },
  { label: "Une majuscule", test: (p) => /[A-Z]/.test(p) },
  { label: "Un chiffre", test: (p) => /\d/.test(p) },
];

export default function PasswordRequirements({ password }) {
  return (
    <ul className="list-unstyled mb-0" style={{ fontSize: "0.8rem" }}>
      {rules.map((rule, i) => {
        const ok = rule.test(password);
        return (
          <li key={i} className={ok ? "text-success" : "text-muted"}>
            <FaCheck
              size={10}
              className="me-1"
              style={{ opacity: ok ? 1 : 0.3 }}
            />
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
